import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DxButtonComponent } from 'devextreme-angular';
import { Dipendente } from 'src/app/models/dipendente';
import { TipiArticoli } from 'src/app/models/tipi-articoli';
import { ArticoliConsegnatiComponent } from 'src/app/shared/components/articoli/articoli-consegnati/articoli-consegnati.component';
import { GestioneArticoliPrevistiComponent } from 'src/app/shared/components/dipendenti/gestione-articoli-previsti/gestione-articoli-previsti.component';
import { FormDipendenteComponent } from 'src/app/shared/components/form/form-dipendente/form-dipendente.component';
import { GestArticoliBaseComponent } from 'src/app/shared/components/gest-articoli-base/gest-articoli-base.component';
import { GridAllegatiDipendenteComponent } from 'src/app/shared/components/grid/grid-allegati-dipendente/grid-allegati-dipendente.component';
import { GridScadenzeDipendentiComponent } from 'src/app/shared/components/grid/grid-scadenze-dipendenti/grid-scadenze-dipendenti.component';
import { DipendentiService } from 'src/app/shared/services/dipendenti.service';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import { ConvertError } from 'src/app/utils/gestione-errori';
import { notificaMessaggio } from 'src/app/utils/notifiche-utils';

@Component({
  selector: 'app-dipendenti-edt',
  templateUrl: './dipendenti-edt.component.html',
  styleUrls: ['./dipendenti-edt.component.scss'],
  imports: [
    FormDipendenteComponent,
    DxButtonComponent,
    GridAllegatiDipendenteComponent,
    ArticoliConsegnatiComponent,
    GestioneArticoliPrevistiComponent,
    GridScadenzeDipendentiComponent,
  ],
  standalone: true,
})
export class DipendentiEdtComponent
  extends GestArticoliBaseComponent
  implements OnInit
{
  private route = inject(ActivatedRoute);
  private navService = inject(NavigatorService);
  private dipendentiService = inject(DipendentiService);
  idDipendente: number = 0;
  dipendente: Dipendente = new Dipendente();
  isNew = false;
  dipendentiNominativo: string = '';
  listTipiArticoli: TipiArticoli[] = [];

  ngOnInit() {
    const idDipendenteParam = this.route.snapshot.paramMap.get('id');
    if (!idDipendenteParam || idDipendenteParam == '0') {
      this.navService.goToHome();
    } else {
      this.idDipendente = +idDipendenteParam;
      this.loadDipendente();
    }
  }

  loadDipendente() {
    if (this.idDipendente > 0) {
      this.dipendentiService.get(this.idDipendente).subscribe({
        next: (res) => {
          if (res != null) {
            this.dipendente = res;
            this.dipendentiNominativo = res.nominativo;
          } else {
            notificaMessaggio('Dipendente non presente', 'warning');
            this.navService.goToHome();
          }
        },
        error: (error) => {
          ConvertError(error, 'Errore recupero dipendente');
        },
      });
    }
  }

  goToDashboardDipendente() {
    this.navService.goToDipedenteDashboard(this.idDipendente); // Reindirizzo alla dashboard dell'articolo
  }
}
